import { BoardResource } from "dtos/kanban.dto";
// import { LoanStatus } from "dtos/app-creditor-map.dto";
// import { LOAN_STATUS_META } from "../Application/constants";
import { pickColorFromSeed, pickRandomIcon } from "./MetaItems";

export type ColumnFormValue = {
  name: string;
  description?: string;
  action?: string;
  meta?: { icon?: string };
};

export type GroupFormValue = {
  name: string;
  columns: ColumnFormValue[];
  meta?: { color?: string };
};

export type ConfigTemplate = {
  key: string;
  label: string;
  for: BoardResource[];
  config: { groups: GroupFormValue[]; ungroupedColumns: ColumnFormValue[] };
};

// const FINAL_STAGE_STATUSES = new Set<LoanStatus>([LoanStatus.CANCELLED, LoanStatus.COMPLETE]);

// const toColumn = (status: LoanStatus): ColumnFormValue => ({
//   name: LOAN_STATUS_META[status].label,
//   description: "",
//   action: LOAN_STATUS_META[status].actionHint,
//   meta: { icon: pickRandomIcon() },
// });

// const defaultStageColumns = (Object.values(LoanStatus) as LoanStatus[])
//   .filter((s) => !FINAL_STAGE_STATUSES.has(s))
//   .map(toColumn);

// const finalStageColumns = [...FINAL_STAGE_STATUSES].map(toColumn);

// export const LOAN_STATUS_TEMPLATE: ConfigTemplate = {
//   key: "tpl-loan-status",
//   label: "Loan Status",
//   for: [BoardResource.LOAN],
//   config: {
//     groups: [
//       {
//         name: "Default Stage",
//         meta: { color: pickColorFromSeed("default_stage").solid },
//         columns: defaultStageColumns,
//       },
//       {
//         name: "Final Stage",
//         meta: { color: pickColorFromSeed("final_stage").solid },
//         columns: finalStageColumns,
//       },
//     ],
//     ungroupedColumns: [],
//   },
// };

export const ConfigTemplates: ConfigTemplate[] = [];
